export default __webpack_public_path__ + "static/media/1033.3c8a16b2.svg";